import { Dispatch, SetStateAction } from "react"

import { IDocSubtypes } from "../interfaces";

import api from "services/api"


interface IDocTypesResponse {
  data: {
    results: {
      name: string;
      description: string;
      document_subtypes: [{
        id: string;
        name: string;
        description: string;
        document_type_id: string;
      }]
    }[];
  }
}

export const EnsureDocumentType = async (
  setState: Dispatch<SetStateAction<Array<IDocSubtypes>>>
) => {
  try {
    const response = await api.get('/document-types') as IDocTypesResponse

    const subtypes = response?.data?.results?.find(
      (documentType) => documentType.name.toLowerCase().includes('documento de identificação')
    )?.document_subtypes || response?.data?.results[0]?.document_subtypes || [];

    setState(subtypes?.map(subtype => (
      { value: subtype.id, label: subtype.name }
    )))

    return Promise.resolve()
  } catch (error: any) {
    return Promise.reject(error?.response?.data?.message)
  }
}
